export enum EnterpriseAiDetectionTabsEnum {
    Activity = "activity",
    Findings = "findings",
    Prevention = "prevention",
    DataInsights = "data-insights",
    inLineControl = "inLine-control",
}
